import { BASE_URL } from './Config.js';

export class ClientService {
  createClient = async (clientData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/client/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(clientData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la création');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error creating client:', error); throw error; }
  };

  getAllClients = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/client/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch clients');
      return await response.json();
    } catch (error) { console.error('Error fetching clients:', error); throw error; }
  };

  getClientById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/client/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch client');
      return await response.json();
    } catch (error) { console.error('Error fetching client:', error); throw error; }
  };

  updateClient = async (id, clientData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/client/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(clientData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la mise à jour');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error updating client:', error); throw error; }
  };

  deleteClient = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/client/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to delete client');
      return true;
    } catch (error) { console.error('Error deleting client:', error); throw error; }
  };

    searchClients = async (query) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/client/search?query=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}` 
      }
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la recherche des clients');
    }
    return await response.json();
  };
}